import { useCallback } from 'react';
import { pick, prop } from 'ramda';

import { usePortletConfig } from 'js/components/system/Portlet';

import { DYNAMIC_CATEGORIES } from 'js/app/components/main/Games/constants';
import { useGamesSelector } from 'js/app/components/main/Games/store/context';
import { useRecentlyGamesSelector } from 'js/app/store/hooks/useRecentlyGames';
import { useAppSelector, useUserSelector } from 'js/store/hooks';

export const useIsCategoryLoading = () => {
    const { pggGameList } = useGamesSelector();
    const isFavoritesFetching = useAppSelector(prop('isFavoritesFetching'));
    const { isLoggedIn, futureAnthemsList } = useUserSelector(pick(['isLoggedIn', 'futureAnthemsList']));
    const { recentlyPlayedLoading } = useRecentlyGamesSelector();
    const { customCategories: { category: customCategories = [] } = {} } = usePortletConfig();

    return useCallback((category) => {
        const isPggEnabled = category.pgg2?.enabled;
        const {
            futureAnthemsEnabled,
            futureAnthemsRecommendationType
        } = customCategories.find(({ categoryName }) => categoryName === category.name) || {};
        const {
            fetched: isFutureAnthemsFetched
        } = futureAnthemsList[futureAnthemsRecommendationType] || {};

        return category.name === DYNAMIC_CATEGORIES.RECENTLY && recentlyPlayedLoading
            || category.name === DYNAMIC_CATEGORIES.FAVOURITES && isFavoritesFetching
            || isPggEnabled && !pggGameList?.[category.name]?.fetched
            || futureAnthemsEnabled && isLoggedIn && !isFutureAnthemsFetched;
    }, [
        isLoggedIn,
        pggGameList,
        customCategories,
        futureAnthemsList,
        isFavoritesFetching,
        recentlyPlayedLoading
    ]);
};
